module.exports = __webpack_public_path__ + "assets/hide-settings.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/hide-settings.svg
// module id = 329
// module chunks = 0